/* PQ Global i18n — FR/EN translations for all pages */
(function () {

  var LANGS = {
    fr: {
      /* ── Header nav ─── */
      nav_home: 'Accueil',
      nav_products: 'Produits',
      nav_products_peptides_label: 'Peptides',
      nav_products_peptides_sub: 'Tous nos peptides de recherche',
      nav_products_bac_label: 'Bac Water',
      nav_products_bac_sub: 'Eau bactériostatique',
      nav_legal: 'Légal',
      nav_legal_privacy_label: 'Confidentialité',
      nav_legal_privacy_sub: 'Politique de confidentialité',
      nav_legal_refund_label: 'Remboursement',
      nav_legal_refund_sub: 'Politique de remboursement',
      nav_legal_terms_label: 'Conditions',
      nav_legal_terms_sub: "Conditions d'utilisation",
      nav_cta: 'Boutique',
      nav_mobile_products: 'Produits',
      nav_mobile_legal: 'Légal',
      nav_mobile_privacy: 'Confidentialité',
      nav_mobile_refund: 'Remboursement',
      nav_mobile_terms: 'Conditions',
      nav_mobile_cart: 'Panier',
      nav_mobile_cta: 'Voir les Peptides',
      search_placeholder: 'Rechercher des peptides, eau BAC…',
      search_hint: 'Commencez à taper pour rechercher des produits',
      search_section: 'Produits',
      search_no_results: 'Aucun résultat pour',
      /* ── Footer ─── */
      ft_brand_desc: 'Source canadienne de peptides de recherche. Chaque lot vérifié par des laboratoires tiers indépendants. Expédition le jour même depuis le Québec.',
      ft_email_placeholder: 'Votre courriel',
      ft_submit: "S'inscrire",
      ft_col_shop: 'Boutique',
      ft_all_products: 'Tous les produits',
      ft_cart: 'Panier',
      ft_col_legal: 'Légal',
      ft_privacy: 'Confidentialité',
      ft_refund: 'Remboursement',
      ft_terms: 'Conditions',
      ft_shipping: 'Expédition',
      ft_col_support: 'Support',
      ft_contact: 'Contact',
      ft_research: 'Recherche',
      ft_copy: '© {year} Peptides Québec. Tous droits réservés.',
      ft_disclaimer: 'Strictement réservé à la recherche scientifique in vitro et in vivo. Non destiné à la consommation humaine ou animale. Non destiné à diagnostiquer, traiter, guérir ou prévenir une maladie.',
      /* ── PDP ─── */
      pdp_review: 'Qualité recherche · ≥98% pureté',
      pdp_save: 'Économie',
      pdp_in_stock: 'En stock',
      pdp_low_stock: 'Plus que {n} restants',
      pdp_sold_out_stock: 'Épuisé',
      pdp_qty_label: 'Qté',
      pdp_atc: 'Ajouter au panier',
      pdp_sold_out_btn: 'Épuisé',
      pdp_buy_now: 'Acheter maintenant',
      pdp_adding: 'Ajout…',
      pdp_added: 'Ajouté !',
      pdp_try_again: 'Réessayer',
      pdp_trust_purity: '≥98% Pureté',
      pdp_trust_tested: 'Testé en labo',
      pdp_trust_ship: 'Livraison gratuite 300$+',
      pdp_trust_dispatch: 'Expédition 24h',
      pdp_home: 'Accueil',
      pdp_products_crumb: 'Produits',
      /* ── Collection page ─── */
      col_home: 'Accueil',
      col_catalogue: 'Catalogue',
      col_eyebrow: 'Research Grade · Pureté Certifiée',
      col_title: 'Nos Produits',
      col_desc: "Chaque composé est analysé par des laboratoires tiers accrédités et indépendants de Peptides Québec. Certificat d'analyse disponible pour chaque lot.",
      col_step_synth: 'Synthèse',
      col_step_lyoph_process: 'Lyophilisation',
      col_step_hplc: 'Analyse HPLC',
      col_step_ms: 'Spectrométrie MS',
      col_step_coa: 'COA Émis',
      col_stat_purity_lbl: 'Pureté HPLC',
      col_stat_lab_lbl: 'Labo tiers',
      col_stat_orders_lbl: 'Commandes',
      col_qa_verified: 'Vérifié',
      col_qa_purity_lbl: 'Pureté HPLC',
      col_qa_purity_sub: 'Mesuré par chromatographie liquide haute performance · Certifié par lot',
      col_qa_chrom_lbl: 'Chromatographie',
      col_qa_spec_lbl: 'Spectrométrie',
      col_qa_cert_lbl: 'Certificat',
      col_qa_storage_lbl: 'Stockage',
      col_qa_check1: '<strong>Labo tiers accrédité</strong> — Indépendant de Peptides Québec, aucun conflit d\'intérêt',
      col_qa_check2: '<strong>Traçabilité par lot</strong> — Chaque flacon lié à son rapport d\'analyse complet',
      col_qa_check3: '<strong>Lyophilisé &amp; scellé sous argon</strong> — Stabilité maximale, sans solvant résiduel',
      col_qa_check4: '<strong>COA disponible sur demande</strong> — Fourni pour chaque produit commandé',
      col_filter_all: 'Tous',
      col_sort_default: 'Trier par',
      col_sort_price_asc: 'Prix croissant',
      col_sort_price_desc: 'Prix décroissant',
      col_sort_name: 'Nom A–Z',
      col_from: 'Dès',
      col_sold_out: 'Épuisé',
      col_lyoph: 'Lyophilisé',
      col_empty: 'Aucun produit trouvé.',
      col_disclaimer_badge: 'Avertissement — Usage de recherche uniquement',
      col_disclaimer_text: 'Tous les peptides listés sont strictement destinés à la recherche scientifique in vitro et in vivo. Ces produits ne sont pas approuvés par Santé Canada pour un usage humain ou animal. Non destinés à diagnostiquer, traiter, guérir ou prévenir une quelconque maladie. Usage réservé aux chercheurs qualifiés.',
      col_count_s: 'produit',
      col_count_p: 'produits',
      col_atc: 'Ajouter au panier',
      col_adding: 'Ajout…',
      col_added: 'Ajouté !',
      col_try_again: 'Réessayer',
      col_sold_out_btn: 'Épuisé',
      col_variant_sold_out: ' — Épuisé',
      /* ── Cart page ─── */
      cart_back: 'Continuer les achats',
      cart_title: 'Votre Panier',
      cart_empty_h2: 'Votre panier est vide',
      cart_empty_p: 'Parcourez notre catalogue de peptides de recherche<br>vérifiés HPLC par des laboratoires indépendants.',
      cart_empty_btn: 'Voir les Produits',
      cart_freeship_unlocked: 'Livraison gratuite débloquée !',
      cart_freeship_remaining: 'Plus que <strong>{amount}</strong> pour la livraison gratuite',
      cart_urgency: 'Traitement de la commande en <span>24h</span> depuis le Québec.',
      cart_upsell_label: 'Souvent commandé ensemble',
      cart_upsell_sub: 'Eau bactériostatique — essentielle pour la reconstitution',
      cart_upsell_add: 'Ajouter',
      cart_upsell_added: 'Ajouté',
      cart_chip_lyoph: 'Lyophilisé',
      cart_summary_title: 'Récapitulatif',
      cart_subtotal: 'Sous-total',
      cart_shipping_label: 'Livraison',
      cart_shipping_free: 'Gratuite',
      cart_shipping_calc: 'Calculée à la caisse',
      cart_taxes_label: 'Taxes',
      cart_taxes_calc: 'Calculées à la caisse',
      cart_total_label: 'Total estimé',
      cart_total_note: 'Hors taxes et livraison',
      cart_checkout: 'Passer à la caisse en toute sécurité',
      cart_ssl: 'Connexion SSL 256-bit · Données chiffrées',
      cart_continue: 'Continuer les achats',
      cart_payment_header: 'Paiement par virement Interac uniquement',
      cart_payment_text: "Les peptides de recherche se trouvent actuellement dans une zone grise au Canada. Ils sont légaux pour usage scientifique, mais les processeurs de paiement par carte refusent pour l'instant de traiter les transactions liées à ce type de produits. Le virement Interac est donc notre seule méthode de paiement disponible. C'est rapide, sécurisé et 100% canadien. Vous recevrez les instructions de virement par courriel après avoir passé votre commande.",
      cart_trust1: 'Pureté vérifiée HPLC ≥98% — COA disponible',
      cart_trust2: 'Emballage discret — expédition depuis le Québec',
      cart_trust3: 'Traitement de la commande en 24h',
      cart_mobile_total: 'Total estimé',
      cart_mobile_checkout: 'Commander',
      cart_add_more: 'Ajouter des produits',
      cart_unit: '/ u',
      cart_pill_qc: 'Depuis le Québec',
      cart_delivery_label: 'Livraison estimée',
      cart_delivery_note: 'après réception du paiement Interac',
      cart_interac_why: 'Pourquoi le virement Interac ?',
      interac_title: 'Paiement par virement Interac',
      interac_subtitle: 'Note réglementaire · Canada',
      interac_s1_title: 'Statut légal',
      interac_s1_body: "Les peptides de recherche ne sont pas explicitement définis comme médicaments sous la <a href='https://laws-lois.justice.gc.ca/fra/lois/f-27/' target='_blank' rel='noopener'>Loi sur les aliments et drogues (L.R.C. 1985, ch. F-27)</a>, lorsque vendus strictement pour recherche scientifique in vitro, sans représentation d'usage thérapeutique.",
      interac_s2_title: 'Réseaux de paiement',
      interac_s2_body: "Visa et Mastercard classent automatiquement ces produits dans des catégories à risque élevé selon leur politique interne, indépendamment de leur légalité au Canada. Cette restriction n'est pas imposée par la loi.",
      interac_s3_title: 'Comment ça fonctionne',
      interac_s3_body: "Dès que votre commande est passée, un courriel de confirmation vous est automatiquement envoyé. Les étapes du virement y sont clairement détaillées : l'adresse destinataire, le montant exact et les instructions complètes. Il vous suffit de suivre ce courriel pour finaliser votre paiement. Votre commande est traitée dès réception du virement, généralement dans un délai de 1 à 2 heures ouvrables.",
      interac_confirm: 'Procéder à la caisse',
      interac_cancel: 'Retour au panier',
      /* ── Page / FAQ chrome ─── */
      pg_badge_legal: 'Peptides Québec · Information légale',
      pg_badge_support: 'Peptides Québec · Support',
      pg_updated: 'Mis à jour le',
      pg_questions: 'Questions ?',
      pg_contact: 'Contactez-nous',
      pg_toc: 'Sur cette page',
      pg_cta_title: 'Une question sur cette politique ?',
      pg_cta_sub: 'Notre équipe est disponible pour vous aider.',
      pg_cta_btn: 'Nous contacter',
      /* ── Peptide Calculator ─── */
      calc_back: 'Retour au Guide Peptides',
      calc_crumb_cur: 'Calculatrice Peptides',
      calc_hero_badge: 'Peptides Québec · Outil de recherche',
      calc_hero_sub: 'Un outil multi-fonctions premium conçu pour les calculs de reconstitution, la planification du tirage en seringue, la couverture totale du flacon, la prévision de sessions et l\'organisation structurée de la recherche.',
      calc_hero_disclaimer_title: 'Usage de recherche uniquement',
      calc_hero_disclaimer_text: 'Cet outil est destiné uniquement à la planification de la recherche scientifique in vitro. Les résultats sont des sorties mathématiques basées sur vos entrées — vérifiez toujours avec du personnel qualifié. Non destiné à un usage humain ou animal.',
      calc_hero_browse: 'Parcourir les produits',
      calc_feature_1: 'Interface premium',
      calc_feature_2: 'Préréglages rapides',
      calc_feature_3: 'Résultats visuels',
      calc_feature_4: 'Axé recherche',
      calc_stat_syringe_label: 'Standard seringue',
      calc_stat_presets_label: 'Préréglages',
      calc_stat_draw_label: 'Tirage max affiché',
      calc_stat_conc_label: 'Concentration instantanée',
      calc_dd_eyebrow: 'Tirage & Dosage',
      calc_dd_title: 'Calculatrice de Dosage Peptide',
      calc_dd_sub: 'Sélectionnez votre dose, la force du flacon et le volume d\'eau bactériostatique — puis appuyez sur Calculer.',
      calc_dd_card_title: 'Tirage & Dosage',
      calc_dd_card_sub: 'Choisissez vos valeurs parmi les options prédéfinies ci-dessous',
      calc_col1_label: 'Dose de Peptide',
      calc_col2_label: 'Force du Flacon',
      calc_col3_label: 'Eau Bactériostatique',
      calc_other: 'Autre',
      calc_calc_btn: 'Calculer',
      calc_summary_default: 'Sélectionnez une valeur dans chaque colonne pour calculer votre tirage',
      calc_no_data_title: 'Aucun résultat',
      calc_no_data_sub: 'Sélectionnez une dose, une force de flacon et un volume d\'eau BAC ci-dessus — puis appuyez sur Calculer',
      calc_res_draw_label: 'Tirage Seringue',
      calc_res_conc_label: 'Concentration',
      calc_res_conc_sub: 'mcg / mL (μg/mL)',
      calc_res_doses_label: 'Doses par Flacon',
      calc_syr_title: 'Visualisation seringue — U-100 (1 mL / 100 unités)',
      calc_warn_title: 'Usage de recherche uniquement',
      calc_warn_text: 'Cette calculatrice est destinée uniquement à la planification de la recherche scientifique in vitro. Les résultats sont des sorties mathématiques — vérifiez toujours avec du personnel qualifié. Non destiné à un usage humain ou animal.',
      calc_plan_eyebrow: 'Planification de session',
      calc_plan_title: 'Planificateur de Recherche',
      calc_plan_sub: 'Projetez vos injections totales, besoins en matériel et intervalles pour toute une durée de protocole de recherche.',
      calc_plan_card_title: 'Planificateur de Recherche',
      calc_plan_card_sub: 'Remplissez les détails du protocole pour projeter les besoins en matériel',
      calc_plan_dose_label: 'Quantité par injection (mg)',
      calc_plan_duration_label: 'Durée (semaines)',
      calc_plan_freq_label: 'Fréquence d\'injection',
      calc_plan_freq_default: '— Sélectionner la fréquence —',
      calc_plan_freq_daily: 'Quotidien (7×/semaine)',
      calc_plan_freq_eod: 'Jours alternés (EOD)',
      calc_plan_freq_2w: 'Deux fois par semaine',
      calc_plan_freq_1w: 'Une fois par semaine',
      calc_plan_freq_biweekly: 'Bihebdomadaire',
      calc_plan_freq_custom: 'Fréquence personnalisée',
      calc_plan_vial_label: 'Force du flacon (mg chacun)',
      calc_plan_btn: 'Calculer le Planificateur',
      calc_plan_hint: 'Les résultats se mettent à jour au calcul',
      calc_plan_empty: 'Remplissez les champs ci-dessus et cliquez sur Calculer le Planificateur pour projeter vos quantités',
      calc_plan_inj_label: 'Total d\'injections',
      calc_plan_inj_sub: 'sur toute la durée',
      calc_plan_mg_label: 'Matériel total requis',
      calc_plan_interval_label: 'Intervalle d\'injection',
      calc_plan_interval_sub: 'entre les doses',
      calc_plan_summary_title: 'Résumé du protocole',
      calc_prod_eyebrow: 'Boutique',
      calc_prod_title: 'Commencez avec les bons produits',
      calc_prod_sub: 'Tout ce dont vous avez besoin pour la reconstitution et la recherche — chez Peptides Québec.',
      calc_prod_1_name: 'Flacons de Peptides',
      calc_prod_1_tag: 'Gamme complète',
      calc_prod_2_name: 'Eau Bactériostatique',
      calc_prod_2_tag: 'Eau BAC — 30mL',
      calc_prod_3_name: 'Kits de Recherche',
      calc_prod_3_tag: 'Essentiels groupés',
      calc_prod_4_name: 'BPC-157',
      calc_prod_4_tag: 'Flacons 5mg · 10mg',
      calc_prod_5_name: 'TB-500',
      calc_prod_5_tag: 'Flacons 5mg · 10mg',
      calc_prod_6_name: 'Ipamorelin / CJC',
      calc_prod_6_tag: 'Flacons peptides GH',
      calc_shop_all: 'Voir tous les produits',
      calc_wf_label: 'Processus',
      calc_wf_title: 'Du Calcul à la Sélection Confiante',
      calc_wf_sub: 'Aucune conversion manuelle. Aucune incertitude. La calculatrice traduit votre dose en un tirage précis, affiche la concentration en temps réel, et projette exactement combien de flacons votre protocole nécessite.',
      calc_wf_btn1: 'Voir tous les produits',
      calc_wf_btn2: 'Lire le Guide',
      calc_wf_step1_title: 'Entrez la dose',
      calc_wf_step1_sub: 'Préréglage ou entrée mg personnalisée',
      calc_wf_step2_title: 'Choisissez le flacon',
      calc_wf_step2_sub: 'Force 5mg–100mg',
      calc_wf_step3_title: 'Définissez l\'eau BAC',
      calc_wf_step3_sub: 'Volume 0,5mL–5mL',
      calc_wf_step4_title: 'Obtenez les résultats',
      calc_wf_step4_sub: 'Tirage instant + concentration',
      calc_trust_eyebrow: 'Pourquoi cet outil',
      calc_trust_title: 'Conçu pour paraître plus fiable',
      calc_trust_sub: 'Chaque fonctionnalité de cette calculatrice a été conçue autour de la précision, de la clarté et des résultats de grade recherche.',
      calc_trust_1_title: 'Calculs de reconstitution simplifiés',
      calc_trust_1_desc: 'Entrez la force de votre flacon et le volume d\'eau BAC — la calculatrice convertit instantanément en quantité de tirage exacte, concentration précise en mcg/mL, et nombre de doses par flacon. Sans tableur, sans calcul mental.',
      calc_trust_2_title: 'Visualisation des résultats',
      calc_trust_2_desc: 'La barre de remplissage de seringue traduit les unités abstraites en quelque chose de visuellement immédiat. Retour codé par couleur — sarcelle pour les tirages sûrs, ambre pour les grands, rouge pour dépassement.',
      calc_trust_3_title: 'Utilitaire de planification',
      calc_trust_3_desc: 'Le Planificateur de Recherche va au-delà d\'une seule dose. Entrez votre fréquence et durée d\'injection et il projette le total d\'injections, le matériel total en mg, combien de flacons commander, et votre intervalle de dosage.',
      calc_trust_4_title: 'Pont commercial',
      calc_trust_4_desc: 'Une fois que vous savez exactement ce dont vous avez besoin, la section produits affiche les flacons de peptides et l\'eau bactériostatique correspondants de Peptides Québec — pour que le chemin du calcul à la commande soit un seul clic.',
      calc_about_card_title: 'À propos de Peptides Québec',
      calc_about_card_sub: 'Source canadienne de peptides de grade recherche',
      calc_about_p1: 'Peptides Québec est une source premium de <strong>peptides lyophilisés de grade recherche</strong>, au service des laboratoires, institutions de recherche et chercheurs qualifiés à travers le Canada. Nous nous spécialisons dans la fourniture de composés de haute pureté avec documentation complète — chaque lot est accompagné d\'un Certificat d\'Analyse.',
      calc_about_p2: 'Notre gamme comprend des sécrétagogues d\'hormone de croissance, des peptides de réparation, des composés métaboliques et des matériaux de support comme l\'eau bactériostatique — tout ce qui est nécessaire pour un protocole de reconstitution complet.',
      calc_about_p3: '<strong>Pourquoi utiliser cette calculatrice ?</strong> Les calculs de reconstitution impliquent trois variables interdépendantes — dose, solvant et concentration. Cette calculatrice élimine le risque d\'erreur en calculant simultanément le tirage, la concentration et le nombre de doses.',
      calc_about_fact1_title: 'Planification du tirage en seringue',
      calc_about_fact1_sub: 'Convertit la dose et la concentration en unités précises pour seringue à insuline U-100 — élimine l\'ambiguïté de mesure.',
      calc_about_fact2_title: 'Calculs de reconstitution',
      calc_about_fact2_sub: 'Calcul instantané de la concentration à partir de la force du flacon et du volume d\'eau BAC — chaque combinaison, instantanément.',
      calc_about_fact3_title: 'Planification de la recherche',
      calc_about_fact3_sub: 'Projetez les injections totales, le matériel total et les flacons nécessaires pour n\'importe quelle durée et fréquence de protocole.',
      calc_about_fact4_title: 'Vérifications de concentration',
      calc_about_fact4_sub: 'Les tableaux de référence couvrent les flacons de 5mg, 10mg et 20mg sur tous les volumes d\'eau BAC courants.',
      calc_faq_eyebrow: 'FAQ',
      calc_faq_title: 'Questions fréquentes',
      calc_faq_sub: 'Questions courantes sur la calculatrice, les calculs peptides et la planification de recherche.',
      calc_faq_q1: 'À quoi sert la calculatrice de dosage ?',
      calc_faq_a1: 'La calculatrice convertit votre dose de peptide (mg), la force du flacon (mg) et le volume d\'eau bactériostatique (mL) en trois sorties clés : <strong>quantité de tirage</strong> en unités U-100 et mL, <strong>concentration de travail</strong> en mcg/mL, et <strong>doses totales par flacon</strong>.',
      calc_faq_q2: 'Puis-je utiliser cet outil pour plusieurs composés ?',
      calc_faq_a2: 'Oui. La calculatrice est indépendante du composé — elle fonctionne pour tout peptide lyophilisé reconstitué avec de l\'eau bactériostatique et tiré avec une seringue à insuline U-100. Changez simplement les entrées de dose et de force du flacon pour chaque composé.',
      calc_faq_q3: 'À quoi sert le Planificateur de Recherche ?',
      calc_faq_a3: 'Le Planificateur de Recherche étend la calculatrice à plusieurs sessions. Entrez votre quantité d\'injection, la durée du protocole en semaines et la fréquence pour calculer le <strong>nombre total d\'injections</strong>, le <strong>matériel total requis en mg</strong>, <strong>combien de flacons commander</strong>, et votre <strong>intervalle d\'injection en jours</strong>.',
      calc_faq_q4: 'Quelle quantité d\'eau bactériostatique utiliser ?',
      calc_faq_a4: 'Cela dépend de votre concentration cible et de votre dose. Pour un <strong>flacon de 5mg</strong>, ajouter 2mL d\'eau BAC donne 2 500 mcg/mL — la configuration la plus couramment recommandée. La règle générale : <strong>plus d\'eau = concentration plus faible = tirage plus grand par dose</strong>.',
      calc_faq_q5: 'Qu\'est-ce qu\'une seringue à insuline U-100 ?',
      calc_faq_a5: 'Une seringue à insuline U-100 contient 1mL avec 100 graduations — chaque unité égale 0,01mL. C\'est l\'outil standard pour mesurer et injecter les solutions peptidiques reconstituées. La calculatrice affiche votre tirage en <strong>unités</strong> (pour lire la seringue directement) et en <strong>mL</strong> (pour vérification).',
      calc_faq_q6: 'Que m\'indique la barre de remplissage de la seringue ?',
      calc_faq_a6: 'La barre est une représentation visuelle de la quantité d\'une seringue standard de 1mL (100 unités) que vous remplirez par dose. <strong>Remplissage sarcelle</strong> = tirage normal. <strong>Remplissage ambre</strong> = grand tirage (plus de 80 unités). <strong>Remplissage rouge</strong> = le tirage dépasse une seringue complète — ajoutez plus d\'eau BAC pour diluer.',
      calc_nl_badge: 'Accès exclusif',
      calc_nl_title: 'Alertes de réapprovisionnement, offres exclusives & prix membres',
      calc_nl_sub: 'Soyez le premier informé des nouvelles arrivées, des composés épuisés de retour et des prix exclusifs pour les abonnés.',
      calc_nl_perk1: 'Alertes réapprovisionnement',
      calc_nl_perk2: 'Accès anticipé',
      calc_nl_perk3: 'Offres exclusives',
      calc_nl_perk4: 'Mises à jour COA',
      calc_nl_btn: 'S\'inscrire',
      calc_nl_fine: 'Aucun spam. Mises à jour produits uniquement.',
    },
    en: {
      /* ── Header nav ─── */
      nav_home: 'Home',
      nav_products: 'Products',
      nav_products_peptides_label: 'Peptides',
      nav_products_peptides_sub: 'All our research peptides',
      nav_products_bac_label: 'Bac Water',
      nav_products_bac_sub: 'Bacteriostatic water',
      nav_legal: 'Legal',
      nav_legal_privacy_label: 'Privacy',
      nav_legal_privacy_sub: 'Privacy Policy',
      nav_legal_refund_label: 'Refund',
      nav_legal_refund_sub: 'Refund Policy',
      nav_legal_terms_label: 'Terms',
      nav_legal_terms_sub: 'Terms of Service',
      nav_cta: 'Shop',
      nav_mobile_products: 'Products',
      nav_mobile_legal: 'Legal',
      nav_mobile_privacy: 'Privacy',
      nav_mobile_refund: 'Refund',
      nav_mobile_terms: 'Terms',
      nav_mobile_cart: 'Cart',
      nav_mobile_cta: 'View Peptides',
      search_placeholder: 'Search for peptides, BAC water…',
      search_hint: 'Start typing to search products',
      search_section: 'Products',
      search_no_results: 'No results for',
      /* ── Footer ─── */
      ft_brand_desc: 'Canadian source for research peptides. Every batch verified by independent third-party labs. Same-day shipping from Québec.',
      ft_email_placeholder: 'Your email',
      ft_submit: 'Subscribe',
      ft_col_shop: 'Shop',
      ft_all_products: 'All products',
      ft_cart: 'Cart',
      ft_col_legal: 'Legal',
      ft_privacy: 'Privacy',
      ft_refund: 'Refund',
      ft_terms: 'Terms',
      ft_shipping: 'Shipping',
      ft_col_support: 'Support',
      ft_contact: 'Contact',
      ft_research: 'Research',
      ft_copy: '© {year} Peptides Québec. All rights reserved.',
      ft_disclaimer: 'Strictly for in vitro and in vivo scientific research only. Not intended for human or animal consumption. Not intended to diagnose, treat, cure or prevent any disease.',
      /* ── PDP ─── */
      pdp_review: 'Research grade · ≥98% purity',
      pdp_save: 'Save',
      pdp_in_stock: 'In stock',
      pdp_low_stock: 'Only {n} left',
      pdp_sold_out_stock: 'Sold out',
      pdp_qty_label: 'Qty',
      pdp_atc: 'Add to Cart',
      pdp_sold_out_btn: 'Sold Out',
      pdp_buy_now: 'Buy Now',
      pdp_adding: 'Adding…',
      pdp_added: 'Added!',
      pdp_try_again: 'Try again',
      pdp_trust_purity: '≥98% Purity',
      pdp_trust_tested: 'Lab Tested',
      pdp_trust_ship: 'Free Ship $300+',
      pdp_trust_dispatch: '24h Dispatch',
      pdp_home: 'Home',
      pdp_products_crumb: 'Products',
      /* ── Collection page ─── */
      col_home: 'Home',
      col_catalogue: 'Catalogue',
      col_eyebrow: 'Research Grade · Certified Purity',
      col_title: 'Our Products',
      col_desc: 'Every compound is analyzed by accredited, independent third-party labs separate from Peptides Québec. Certificate of Analysis available for every batch.',
      col_step_synth: 'Synthesis',
      col_step_lyoph_process: 'Lyophilization',
      col_step_hplc: 'HPLC Analysis',
      col_step_ms: 'MS Spectrometry',
      col_step_coa: 'COA Issued',
      col_stat_purity_lbl: 'HPLC Purity',
      col_stat_lab_lbl: 'Third-party lab',
      col_stat_orders_lbl: 'Orders',
      col_qa_verified: 'Verified',
      col_qa_purity_lbl: 'HPLC Purity',
      col_qa_purity_sub: 'Measured by high-performance liquid chromatography · Batch certified',
      col_qa_chrom_lbl: 'Chromatography',
      col_qa_spec_lbl: 'Spectrometry',
      col_qa_cert_lbl: 'Certificate',
      col_qa_storage_lbl: 'Storage',
      col_qa_check1: '<strong>Accredited third-party lab</strong> — Independent from Peptides Québec, no conflict of interest',
      col_qa_check2: '<strong>Batch traceability</strong> — Every vial linked to its full analysis report',
      col_qa_check3: '<strong>Lyophilized &amp; argon-sealed</strong> — Maximum stability, no residual solvent',
      col_qa_check4: '<strong>COA available on request</strong> — Provided for every ordered product',
      col_filter_all: 'All',
      col_sort_default: 'Sort by',
      col_sort_price_asc: 'Price: Low to High',
      col_sort_price_desc: 'Price: High to Low',
      col_sort_name: 'Name A–Z',
      col_from: 'From',
      col_sold_out: 'Sold Out',
      col_lyoph: 'Lyophilized',
      col_empty: 'No products found.',
      col_disclaimer_badge: 'Warning — Research use only',
      col_disclaimer_text: 'All listed peptides are strictly intended for in vitro and in vivo scientific research. These products are not approved by Health Canada for human or animal use. Not intended to diagnose, treat, cure or prevent any disease. For use by qualified researchers only.',
      col_count_s: 'product',
      col_count_p: 'products',
      col_atc: 'Add to Cart',
      col_adding: 'Adding…',
      col_added: 'Added!',
      col_try_again: 'Try again',
      col_sold_out_btn: 'Sold Out',
      col_variant_sold_out: ' — Sold Out',
      /* ── Cart page ─── */
      cart_back: 'Continue Shopping',
      cart_title: 'Your Cart',
      cart_empty_h2: 'Your cart is empty',
      cart_empty_p: 'Browse our catalog of research peptides<br>HPLC-verified by independent laboratories.',
      cart_empty_btn: 'View Products',
      cart_freeship_unlocked: 'Free shipping unlocked!',
      cart_freeship_remaining: '<strong>{amount}</strong> away from free shipping',
      cart_urgency: 'Orders processed in <span>24h</span> from Québec.',
      cart_upsell_label: 'Frequently bought together',
      cart_upsell_sub: 'Bacteriostatic water — essential for reconstitution',
      cart_upsell_add: 'Add',
      cart_upsell_added: 'Added',
      cart_chip_lyoph: 'Lyophilized',
      cart_summary_title: 'Summary',
      cart_subtotal: 'Subtotal',
      cart_shipping_label: 'Shipping',
      cart_shipping_free: 'Free',
      cart_shipping_calc: 'Calculated at checkout',
      cart_taxes_label: 'Taxes',
      cart_taxes_calc: 'Calculated at checkout',
      cart_total_label: 'Estimated total',
      cart_total_note: 'Before taxes & shipping',
      cart_checkout: 'Secure Checkout',
      cart_ssl: '256-bit SSL · Encrypted data',
      cart_continue: 'Continue Shopping',
      cart_payment_header: 'Interac e-Transfer only',
      cart_payment_text: "Research peptides currently exist in a legal grey area in Canada. They are legal for scientific use, but card payment processors currently decline transactions related to these products. Interac e-Transfer is therefore our only available payment method. It's fast, secure and 100% Canadian. You will receive transfer instructions by email after placing your order.",
      cart_trust1: 'HPLC verified purity ≥98% — COA available',
      cart_trust2: 'Discreet packaging — shipped from Québec',
      cart_trust3: 'Order processed within 24h',
      cart_mobile_total: 'Estimated total',
      cart_mobile_checkout: 'Checkout',
      cart_add_more: 'Add products',
      cart_unit: '/ ea',
      cart_pill_qc: 'From Québec',
      cart_delivery_label: 'Estimated delivery',
      cart_delivery_note: 'after Interac payment is received',
      cart_interac_why: 'Why Interac e-Transfer?',
      interac_title: 'Interac e-Transfer Payment',
      interac_subtitle: 'Regulatory note · Canada',
      interac_s1_title: 'Legal status',
      interac_s1_body: "Research peptides are not explicitly defined as drugs under the <a href='https://laws-lois.justice.gc.ca/eng/acts/f-27/' target='_blank' rel='noopener'>Food and Drugs Act (R.S.C. 1985, c. F-27)</a> when sold strictly for in vitro scientific research, without therapeutic-use representation.",
      interac_s2_title: 'Payment networks',
      interac_s2_body: 'Visa and Mastercard automatically classify these products as high-risk under their internal policies, regardless of their legal status in Canada. This restriction is not mandated by law.',
      interac_s3_title: 'How it works',
      interac_s3_body: 'As soon as your order is placed, a confirmation email is automatically sent to you. The transfer steps are clearly outlined in that email: the recipient address, the exact amount, and complete instructions. Simply follow the email to complete your payment. Your order is processed as soon as the transfer is received, typically within 1 to 2 business hours.',
      interac_confirm: 'Proceed to Checkout',
      interac_cancel: 'Back to cart',
      /* ── Page / FAQ chrome ─── */
      pg_badge_legal: 'Peptides Québec · Legal Information',
      pg_badge_support: 'Peptides Québec · Support',
      pg_updated: 'Updated',
      pg_questions: 'Questions?',
      pg_contact: 'Contact us',
      pg_toc: 'On this page',
      pg_cta_title: 'A question about this policy?',
      pg_cta_sub: 'Our team is available to help.',
      pg_cta_btn: 'Contact us',
      /* ── Peptide Calculator ─── */
      calc_back: 'Back to Peptide Guide',
      calc_crumb_cur: 'Dosage Calculator',
      calc_hero_badge: 'Peptides Québec · Research Tool',
      calc_hero_sub: 'A premium multi-tool calculator built for reconstitution math, syringe draw planning, total vial coverage, session forecasting, and structured research organization.',
      calc_hero_disclaimer_title: 'Research Use Only',
      calc_hero_disclaimer_text: 'This calculator is intended for in-vitro laboratory research planning only. Results are mathematical outputs based on your inputs — always verify with qualified research personnel. Not intended for human or animal use.',
      calc_hero_browse: 'Browse Products',
      calc_feature_1: 'Premium UX',
      calc_feature_2: 'Preset Driven',
      calc_feature_3: 'Visual Results',
      calc_feature_4: 'Research First',
      calc_stat_syringe_label: 'Syringe Standard',
      calc_stat_presets_label: 'Dose Presets',
      calc_stat_draw_label: 'Max Draw Displayed',
      calc_stat_conc_label: 'Instant Concentration',
      calc_dd_eyebrow: 'Draw & Dose',
      calc_dd_title: 'Peptide Dose Calculator',
      calc_dd_sub: 'Select your dose, vial strength, and bacteriostatic water volume — then hit Calculate.',
      calc_dd_card_title: 'Draw & Dose',
      calc_dd_card_sub: 'Choose your inputs from the preset options below',
      calc_col1_label: 'Peptide Dose',
      calc_col2_label: 'Vial Strength',
      calc_col3_label: 'Bacteriostatic Water',
      calc_other: 'Other',
      calc_calc_btn: 'Calculate',
      calc_summary_default: 'Select values from each column above to calculate your draw',
      calc_no_data_title: 'No result yet',
      calc_no_data_sub: 'Select a dose, vial strength, and BAC water above — then press Calculate',
      calc_res_draw_label: 'Syringe Draw',
      calc_res_conc_label: 'Concentration',
      calc_res_conc_sub: 'mcg / mL (μg/mL)',
      calc_res_doses_label: 'Doses Per Vial',
      calc_syr_title: 'Syringe Fill Visualization — U-100 (1 mL / 100 units)',
      calc_warn_title: 'Research Use Only',
      calc_warn_text: 'This calculator is intended for in-vitro laboratory research planning only. Results are mathematical outputs based on your inputs — always verify with qualified research personnel. Not intended for human or animal use.',
      calc_plan_eyebrow: 'Session Planning',
      calc_plan_title: 'Research Planner',
      calc_plan_sub: 'Project your total injections, material requirements, and interval timing across a full research duration.',
      calc_plan_card_title: 'Research Planner',
      calc_plan_card_sub: 'Fill in protocol details to project material needs',
      calc_plan_dose_label: 'Amount per Injection (mg)',
      calc_plan_duration_label: 'Duration (weeks)',
      calc_plan_freq_label: 'Injection Frequency',
      calc_plan_freq_default: '— Select frequency —',
      calc_plan_freq_daily: 'Daily (7×/week)',
      calc_plan_freq_eod: 'Alternate Days (EOD)',
      calc_plan_freq_2w: 'Twice a Week',
      calc_plan_freq_1w: 'Weekly',
      calc_plan_freq_biweekly: 'Biweekly (every 2 weeks)',
      calc_plan_freq_custom: 'Custom Frequency',
      calc_plan_vial_label: 'Vial Strength (mg each)',
      calc_plan_btn: 'Calculate Planner',
      calc_plan_hint: 'Results update on calculate',
      calc_plan_empty: 'Fill in the fields above and click Calculate Planner to project your research quantities',
      calc_plan_inj_label: 'Total Injections',
      calc_plan_inj_sub: 'over the full duration',
      calc_plan_mg_label: 'Total Material Needed',
      calc_plan_interval_label: 'Injection Interval',
      calc_plan_interval_sub: 'between doses',
      calc_plan_summary_title: 'Planning Summary',
      calc_prod_eyebrow: 'Shop',
      calc_prod_title: 'Start With The Right Products',
      calc_prod_sub: 'Everything you need for reconstitution and research — sourced from Peptides Québec.',
      calc_prod_1_name: 'Peptide Vials',
      calc_prod_1_tag: 'Full product range',
      calc_prod_2_name: 'Bacteriostatic Water',
      calc_prod_2_tag: 'BAC Water — 30mL',
      calc_prod_3_name: 'Research Kits',
      calc_prod_3_tag: 'Bundled essentials',
      calc_prod_4_name: 'BPC-157',
      calc_prod_4_tag: '5mg · 10mg vials',
      calc_prod_5_name: 'TB-500',
      calc_prod_5_tag: '5mg · 10mg vials',
      calc_prod_6_name: 'Ipamorelin / CJC',
      calc_prod_6_tag: 'GH peptide vials',
      calc_shop_all: 'Shop All Products',
      calc_wf_label: 'Workflow',
      calc_wf_title: 'From Calculation to Confident Selection',
      calc_wf_sub: 'No manual conversions. No second-guessing. The calculator maps your dose to a precise syringe draw, shows your concentration in real time, and projects exactly how many vials your full protocol requires.',
      calc_wf_btn1: 'Shop All Products',
      calc_wf_btn2: 'Read the Guide',
      calc_wf_step1_title: 'Enter Dose',
      calc_wf_step1_sub: 'Preset or custom mg input',
      calc_wf_step2_title: 'Choose Vial',
      calc_wf_step2_sub: '5mg–100mg strength',
      calc_wf_step3_title: 'Set BAC Water',
      calc_wf_step3_sub: '0.5mL–5mL volume',
      calc_wf_step4_title: 'Get Results',
      calc_wf_step4_sub: 'Instant draw + concentration',
      calc_trust_eyebrow: 'Why This Tool',
      calc_trust_title: 'Built to Feel More Reliable',
      calc_trust_sub: 'Every feature of this calculator was designed around precision, clarity, and research-grade outcomes.',
      calc_trust_1_title: 'Cleaner Reconstitution Math',
      calc_trust_1_desc: 'Enter your vial strength and BAC water volume — the calculator instantly converts them into an accurate draw amount, exact concentration in mcg/mL, and the number of doses you can get from each vial. No spreadsheets, no mental math.',
      calc_trust_2_title: 'Visual Result Mapping',
      calc_trust_2_desc: 'The syringe fill bar translates abstract unit counts into something you can immediately see. Color-coded feedback — teal for safe draws, amber for large pulls, red for over-syringe — means no ambiguity at the bench.',
      calc_trust_3_title: 'Planning Utility',
      calc_trust_3_desc: 'The Research Planner goes beyond a single dose. Input your injection frequency and duration and it projects total injections, total material in mg, how many vials to order, and your dosing interval.',
      calc_trust_4_title: 'Retail Bridge',
      calc_trust_4_desc: 'Once you know exactly what you need, the product section surfaces matching peptide vials and bacteriostatic water from Peptides Québec — so the path from calculation to order is a single click.',
      calc_about_card_title: 'About Peptides Québec',
      calc_about_card_sub: "Canada's research-grade peptide source",
      calc_about_p1: 'Peptides Québec is a premium source for <strong>research-grade lyophilized peptides</strong>, serving labs, research institutions, and qualified researchers across Canada. We specialize in providing high-purity compounds with full documentation — every batch comes with a Certificate of Analysis.',
      calc_about_p2: 'Our product range includes growth hormone secretagogues, repair peptides, metabolic compounds, and supporting materials like bacteriostatic water — everything needed for a complete reconstitution protocol under one roof.',
      calc_about_p3: '<strong>Why use this calculator?</strong> Reconstitution math involves three interdependent variables. This tool eliminates that risk by computing the draw, concentration, and dose count simultaneously.',
      calc_about_fact1_title: 'Syringe Draw Planning',
      calc_about_fact1_sub: 'Converts dose and concentration to precise U-100 insulin syringe units — eliminates measurement ambiguity.',
      calc_about_fact2_title: 'Reconstitution Math',
      calc_about_fact2_sub: 'Instant concentration calculation from vial strength and BAC water volume — every combination, instantly.',
      calc_about_fact3_title: 'Research Scheduling',
      calc_about_fact3_sub: 'Project total injections, total material, and vials needed for any protocol duration and frequency.',
      calc_about_fact4_title: 'Concentration Checks',
      calc_about_fact4_sub: 'Reference tables cover 5mg, 10mg, and 20mg vials across all common BAC water volumes.',
      calc_faq_eyebrow: 'FAQ',
      calc_faq_title: 'Frequently Asked Questions',
      calc_faq_sub: 'Common questions about the calculator, peptide math, and research planning.',
      calc_faq_q1: 'What does the dose calculator help with?',
      calc_faq_a1: 'The calculator converts your peptide dose (mg), vial strength (mg), and bacteriostatic water volume (mL) into three key outputs: <strong>syringe draw amount</strong> in U-100 units and mL, <strong>working concentration</strong> in mcg/mL, and <strong>total doses per vial</strong>.',
      calc_faq_q2: 'Can I use this tool for multiple compounds?',
      calc_faq_a2: 'Yes. The calculator is compound-agnostic — it works for any lyophilized peptide that is reconstituted with bacteriostatic water and drawn with a U-100 insulin syringe. Simply change the dose and vial strength inputs for each compound.',
      calc_faq_q3: 'What is the Research Planner for?',
      calc_faq_a3: 'The Research Planner extends the calculator into multi-session territory. Enter your injection amount, protocol duration in weeks, and frequency to calculate <strong>total number of injections</strong>, <strong>total material required in mg</strong>, <strong>how many vials to order</strong>, and your <strong>injection interval in days</strong>.',
      calc_faq_q4: 'How much bacteriostatic water should I use?',
      calc_faq_a4: 'It depends on your target concentration and dose. For a <strong>5mg vial</strong>, adding 2mL of BAC water gives 2,500 mcg/mL — the most commonly recommended configuration. The general rule: <strong>more water = lower concentration = larger syringe draw per dose</strong>.',
      calc_faq_q5: 'What is a U-100 insulin syringe?',
      calc_faq_a5: 'A U-100 insulin syringe holds 1mL and has 100 unit markings — each unit equals 0.01mL. It is the standard tool for measuring and injecting reconstituted peptide solutions. The calculator outputs your draw in both <strong>units</strong> and <strong>mL</strong>.',
      calc_faq_q6: 'What does the syringe fill bar tell me?',
      calc_faq_a6: 'The syringe fill bar is a visual representation of how much of a standard 1mL (100-unit) insulin syringe you will be filling per dose. <strong>Teal fill</strong> = normal draw. <strong>Amber fill</strong> = large draw (over 80 units). <strong>Red fill</strong> = draw exceeds one full syringe — add more BAC water to dilute.',
      calc_nl_badge: 'Insider Access',
      calc_nl_title: 'Restock Alerts, Private Drops & Insider Pricing',
      calc_nl_sub: 'Be first to know when new peptides drop, when out-of-stock compounds are back, and when we run exclusive pricing for subscribers.',
      calc_nl_perk1: 'Restock Alerts',
      calc_nl_perk2: 'Early Access',
      calc_nl_perk3: 'Exclusive Offers',
      calc_nl_perk4: 'COA Updates',
      calc_nl_btn: 'Subscribe',
      calc_nl_fine: 'No spam. Product updates only.',
    }
  };

  window.PQ_LANGS = LANGS;

  function applyGlobal(lang) {
    var t = LANGS[lang] || LANGS.fr;
    window.pqT   = t;
    window.pqLang = lang;

    /* data-i18n text */
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.dataset.i18n;
      if (t[key] !== undefined) el.textContent = t[key];
    });

    /* data-i18n-html (innerHTML — for elements containing tags like <strong>, <span>, <br>) */
    document.querySelectorAll('[data-i18n-html]').forEach(function (el) {
      var key = el.dataset.i18nHtml;
      if (t[key] !== undefined) el.innerHTML = t[key];
    });

    /* data-i18n-placeholder */
    document.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      var key = el.dataset.i18nPlaceholder;
      if (t[key] !== undefined) el.placeholder = t[key];
    });

    /* Toggle pill state */
    document.querySelectorAll('.pq-lang-opt').forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.lang === lang);
    });
    var bg = document.getElementById('pq-lang-bg');
    if (bg) bg.style.transform = lang === 'en' ? 'translateX(100%)' : 'translateX(0)';

    /* Footer copyright year */
    var copy = document.getElementById('pq-ft-copy');
    if (copy) copy.textContent = t.ft_copy.replace('{year}', new Date().getFullYear());

    localStorage.setItem('pq-lang', lang);

    /* Notify all sections so they can update JS-generated text */
    document.dispatchEvent(new CustomEvent('pq-lang-changed', { detail: { lang: lang } }));
  }

  window.pqApplyGlobal = applyGlobal;

  function safeLang(v) { return (v === 'en') ? 'en' : 'fr'; }

  /* Apply on load */
  var lang = safeLang(localStorage.getItem('pq-lang'));
  applyGlobal(lang);

  /* Re-apply after everything is painted */
  window.addEventListener('load', function () {
    applyGlobal(safeLang(localStorage.getItem('pq-lang')));
  });

  /* Delegated click — works regardless of when buttons are in DOM */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pq-lang-opt');
    if (!btn) return;
    var l = btn.dataset.lang;
    if (!l || l === window.pqLang) return;
    applyGlobal(l);
  });

})();
